module.exports = __webpack_public_path__ + "img/cover_photo.fc57821b.jpg";